// extracted by mini-css-extract-plugin
module.exports = {"taxDisclousureLanguageContainer":"tax-disclosure-text_taxDisclousureLanguageContainer__pP_Nr","taxDisclosureLanguageCopy":"tax-disclosure-text_taxDisclosureLanguageCopy__cyvBx"};